import { inject, Injectable, signal } from '@angular/core';

import { UserDto } from '../../../app/api';

/**
 * User Service
 *
 * Manages the current authenticated user's state.
 * In the gateway app, users are gateway administrators with roles (admin/operator/viewer).
 */
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSignal = signal<UserDto | null>(null);
  readonly user = this.userSignal.asReadonly();

  setUser(user: UserDto | null): void {
    this.userSignal.set(user);
  }
}
